import styled from "styled-components";

const ItemField = styled.div`
  width: 100%;
  height: 38px;
  font-size: var(--font-size-small);
  font-weight: normal;
  color: var(--color-black);
  background-color: var(--color-white);
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 10px;
`;

const TextField = styled.input`
  height: 38px;
  width: 600px;
  padding: 0px 10px;
  font-size: var(--font-size-small);
  border: 1px solid var(--color-main);

  &:focus {
    outline: none;
  }
`;

const DatePickerField = styled.input`
  height: 38px;
  width: 150px;
  padding: 0px 10px;
  font-size: var(--font-size-small);
  border: 1px solid var(--color-main);
  cursor: pointer;

  &:focus {
    outline: none;
  }
`;

export { TextField, DatePickerField, ItemField };
